var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scene-list"},_vm._l((_vm.sceneData),function(item,index){return _c('div',{key:index,staticClass:"scene-item"},[_c('div',{staticClass:"mask"}),_c('img',{attrs:{"src":item.src,"alt":""}}),_c('div',{staticClass:"text"},[_c('div',[_vm._v(_vm._s(item.text))]),_c('div',{staticClass:"line"})])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }